import { useCallback, useState } from "react";
import httpService from "../services/api";

const useHttp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendRequest = useCallback( async (requestConfig, withAuthorization, responseMethod) => {
    setIsLoading(true);
    try {            
      responseMethod(await httpService.fetchRequest(requestConfig, withAuthorization));
    } catch (e) {
      setError(e.message);      
    }
    finally {
      setIsLoading(false);
    }
  }, []);

  return {isLoading, error, sendRequest};
};

export default useHttp;